import { makeObservable, observable, runInAction } from "mobx";
import { NotificationStore, NotificationStoreInstance } from "@common/stores";
import { VisitPublicModel } from "@common/models";
import { VisitService } from "@common/services";

export class VisitPublicStore {
    notificationStore!: NotificationStore;
    @observable visit: VisitPublicModel | undefined = undefined;

    constructor() {
        makeObservable(this, undefined, {
            autoBind: true
        });
    }

    async fetchPublicVisit(visitPublicId: string) {
        await VisitService.getPublicVisit(visitPublicId)
            .then(visit => runInAction(() => {
                this.visit = visit
            }))
            .catch(err => NotificationStoreInstance.error("Failed to fetch visit information. " + err));
    }

    async signConsent(visitPublicId: string, consentTypePublicId: string, signaturePhotoDataUrl: string): Promise<boolean> {
        if (visitPublicId === undefined || consentTypePublicId === undefined || signaturePhotoDataUrl === undefined) return false;
        const signatureBase64Encoded = signaturePhotoDataUrl.split(',')[1];
        return await VisitService.signAndStoreConsent(signatureBase64Encoded, visitPublicId, consentTypePublicId, true)
            .then(() => true)
            .catch(() => {
                NotificationStoreInstance.error("Failed to save Treatment Consent signature. Please try again.");
                return false;
            });
    }
}
